// Role enum to match API Role enum
export enum Role {
  ADMIN = "ADMIN",
  USER = "USER"
}

// Updated OrganizationDTO model
export interface OrganizationDTO {
  id?: string; // UUID as string
  name: string;
  street_address?: string;
  city?: string;
  state?: string;
  zip_code?: string;
  phone?: string;
  website?: string;
  mission?: string;
  vision?: string;
  subscription_tier?: string; // 'free', 'growth', or 'impact'
}

// Updated UserDTO model
export interface UserDTO {
  id?: string; // UUID as string
  username: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  active?: boolean;
  role?: Role;
}

// Invitation status enum
export enum InvitationStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  EXPIRED = "EXPIRED",
  RESCINDED = "RESCINDED"
}

// Updated InvitationDTO model
export interface InvitationDTO {
  id?: string; // UUID as string
  email: string;
  organization_id: string; // UUID as string
  role: Role;
  active?: boolean;
  sent_at?: string; // ISO date string
  status?: InvitationStatus; // Status of the invitation
  expires_at?: string; // ISO date string for expiration
}

